import { createApiAction } from 'src/api';

export const FETCH_AUDITS_START = 'audits/fetch_audits_start';
export const FETCH_AUDITS_SUCCESS = 'audits/fetch_audits_success';
export const FETCH_AUDITS_FAILURE = 'audits/fetch_audits_failure';

export const FETCH_AUDIT_START = 'audits/fetch_audit_start';
export const FETCH_AUDIT_SUCCESS = 'audits/fetch_audit_success';
export const FETCH_AUDIT_FAILURE = 'audits/fetch_audit_failure';

export const CREATE_AUDIT_START = 'audits/create_audit_start';
export const CREATE_AUDIT_SUCCESS = 'audits/create_audit_success';
export const CREATE_AUDIT_FAILURE = 'audits/create_audit_failure';

export const UPDATE_AUDIT_START = 'audits/update_audit_start';
export const UPDATE_AUDIT_SUCCESS = 'audits/update_audit_success';
export const UPDATE_AUDIT_FAILURE = 'audits/update_audit_failure';

export const DELETE_AUDIT_START = 'audits/delete_audit_start';
export const DELETE_AUDIT_SUCCESS = 'audits/delete_audit_success';
export const DELETE_AUDIT_FAILURE = 'audits/delete_audit_failure';

export const FETCH_AUDIT_HISTORY_START = 'audits/fetch_audit_history_start';
export const FETCH_AUDIT_HISTORY_SUCCESS = 'audits/fetch_audit_history_success';
export const FETCH_AUDIT_HISTORY_FAILURE = 'audits/fetch_audit_history_failure';

export const fetchAudits = () => createApiAction(
  {
    path: '/api/v1/audits/',
    method: 'GET',
  },
  [FETCH_AUDITS_START, FETCH_AUDITS_SUCCESS, FETCH_AUDITS_FAILURE]
);

export const fetchAudit = (auditId) => createApiAction(
  {
    path: `/api/v1/audits/${auditId}/`,
    method: 'GET',
  },
  [FETCH_AUDIT_START, FETCH_AUDIT_SUCCESS, FETCH_AUDIT_FAILURE]
);

export const createAudit = (auditData) => createApiAction(
  {
    path: '/api/v1/audits/',
    method: 'POST',
    body: auditData,
  },
  [CREATE_AUDIT_START, CREATE_AUDIT_SUCCESS, CREATE_AUDIT_FAILURE]
);

export const updateAudit = (auditId, auditData) => createApiAction(
  {
    path: `/api/v1/audits/${auditId}/`,
    method: 'PUT',
    body: auditData,
  },
  [UPDATE_AUDIT_START, UPDATE_AUDIT_SUCCESS, UPDATE_AUDIT_FAILURE]
);

export const deleteAudit = (auditId) => createApiAction(
  {
    path: `/api/v1/audits/${auditId}/`,
    method: 'DELETE',
  },
  [DELETE_AUDIT_START, DELETE_AUDIT_SUCCESS, DELETE_AUDIT_FAILURE]
);

export const fetchAuditHistory = (auditId) => createApiAction(
  {
    path: `/api/v1/audits/${auditId}/history/`,
    method: 'GET',
  },
  [FETCH_AUDIT_HISTORY_START, FETCH_AUDIT_HISTORY_SUCCESS, FETCH_AUDIT_HISTORY_FAILURE]
);

export const exportAudits = (filters = {}) => (dispatch, getState) => {
  // Get the auth token from state
  const state = getState();
  const token = state.auth?.token;
  
  if (!token) {
    console.error('No authentication token available');
    return;
  }

  // Build query string from filters
  const queryParams = new URLSearchParams();
  
  if (filters.status) queryParams.append('status', filters.status);
  if (filters.account) queryParams.append('account', filters.account);
  if (filters.location) queryParams.append('location', filters.location);
  if (filters.next_audit_date) queryParams.append('next_audit_date', filters.next_audit_date);
  if (filters.last_audit_date) queryParams.append('last_audit_date', filters.last_audit_date);

  const queryString = queryParams.toString();
  const url = `/api/v1/audits/export/${queryString ? `?${queryString}` : ''}`;
  
  // Fetch the file with authentication
  fetch(url, {
    method: 'GET',
    headers: {
      'Authorization': `Token ${token}`,
    },
  })
  .then(response => {
    if (!response.ok) {
      throw new Error('Export failed');
    }
    return response.blob();
  })
  .then(blob => {
    // Create a download link and trigger it
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = 'audits_export.xlsx';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(downloadUrl);
  })
  .catch(error => {
    console.error('Error exporting audits:', error);
  });
};